import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import http from "../services/HttpService";
import config from "../config.json";
import ViewForm from "../components/PortalForms/ViewForm";
import AddEditNotes from "../components/OMCRegistry/AddEditNotes";
import ViewFormModal from "./ViewFormModal";
import { getFieldData } from "../services/appService";
import useDocDownload from "../app/hooks/useDocDownload";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocument, getDocumentDeleteStatus, getDocuments, loadDocuments } from "../app/store/documents";
import { addFormLibrary, getAppFormLibrary, getLibraryFormAddedStatus, loadAppLibraryForms } from "../app/store/forms";
import { getSubcontractorById, getSubsCurrentWfTask, loadSubcontractorById, loadSubcontractorWfTask } from "../app/store/subcontractor";
import { getRecCurrentWfTask, getRecruiterById, loadRecruiterById, loadRecruiterWfTask } from "../app/store/recruiter";
import { getAlert, getConfirmAlert } from "../services/appAlerts";
import CandidateReqDoc from "../components/OMCRegistry/CandidateReqDoc";
import { getCandidateById, loadCandidateById } from "../app/store/candidate";
import { OverlayTrigger, Popover } from "react-bootstrap";
import TimerPopup from "./TimerPopup";
import { getAppTimerMessages, loadAppTimerMessages } from "../app/store/messages";

const InsuranseInformation = (props) => {
  const { workflowTask, item, app, setViewBprmFormShowHide, viewType, insuranceType, setSelectedApp } = props;

  const [formsLib, setFormsLib] = useState([]);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [achFormShowHide, setAchFormShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [achCheckCount, setAchCheckCount] = useState(0);
  const [partnerAppData, setPartnerAppData] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [timerShowHide, setTimerShowHide] = useState(false);
  const [tmrMessages, setTmrMessages] = useState([]);


  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const documentsSelector = useSelector(getDocuments);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const libraryFormAddedStatusSelector = useSelector(getLibraryFormAddedStatus);
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);
  const recruiterByIdSelector = useSelector(getRecruiterById);
  const subcontractorByIdSelector = useSelector(getSubcontractorById);
  const candidateByIdSelector = useSelector(getCandidateById);
  const appTimerMessagesSelector = useSelector(getAppTimerMessages);

  const [handleDownloadFile] = useDocDownload()
  const dispatch = useDispatch();

  useEffect(() => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      dispatch(loadAppLibraryForms(workflowTask.ciid));
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadAppTimerMessages(workflowTask.ciid));
      setAchCheckCount(1);
    }
    // else {
    //   setPartnerCurrentWfTask(null)
    //   if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
    //     dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid))

    //   if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
    //     dispatch(loadRecruiterWfTask(item?.recruiter?.parentid))
    // }
  }, [workflowTask, insuranceType]);


  useEffect(() => {
    setTmrMessages(appTimerMessagesSelector);
  }, [appTimerMessagesSelector])


  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(subsCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(subsCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setPartnerAppData(subsCurrentWfTaskSelector.appData)
      setAchCheckCount(1);
    }
  }, [subsCurrentWfTaskSelector])

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(recCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(recCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setPartnerAppData(recCurrentWfTaskSelector.appData)
      setAchCheckCount(1);
    }
  }, [recCurrentWfTaskSelector])

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const achForms = appFormLibrarySelector.filter(x => x.formType === "Insurance Information");
      if (achForms.length > 0) {
        setFormsLib(achForms);
        setAchCheckCount(0)
      }
      else {
        setFormsLib([]);
        if (achCheckCount === 1) setAchCheckCount(2);
      }
    }
    else {
      setFormsLib([]);
      if (achCheckCount === 1) setAchCheckCount(2);
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    setAppDocuments(documentsSelector);
  }, [documentsSelector]);

  const handleFormShowHide = (f) => {
    setSelectedForm(f);
    setAchFormShowHide(!achFormShowHide);
    setViewBprmFormShowHide(!achFormShowHide);
  };

  const handleNoteShowHide = (type, obj) => {
    if (type === "save") {
      setSelectedForm(null)
      setNoteShowHide(false);
    } else {
      setSelectedForm(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handleCOIDoc = (item) => {
    const docs = appDocuments.filter((x) => x.uploadType === `insurance_${item.id}` && x.deleteFlag !== true);
    if (docs.length === 0) {
      return <button
        className="btn btn-link btn-sm p-0"
        onClick={() =>
          handleUploadDocModalShowHide(`insurance_${item.id}`)
        }
      >
        Upload
      </button>
    }

    return <>
      {docs.map(d =>
        <div className="text-nowrap">
          <button
            className="btn btn-link btn-sm p-0"
            title="Download Document"
            onClick={() => handleDownloadFile(d)}
          >
            {d.docName}
          </button>
          <button
            className="btn btn-sm btn-outline-default p-1 pl-2 pr-2"
            onClick={() => handleDeleteInsuranceDoc(d.docId)}
          >
            <i
              className="fa fa-trash"
              aria-hidden="true"
            ></i>
          </button>
        </div>
      )}
      {getPopover(docs[0].remarks)}
    </>

  }

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <React.Fragment>
        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
          <span
            className="btn-sm btn-link text-primary p-0"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}
          >
            {/* <i className="fa fa-info-circle"></i> */}
            View Notes
          </span>
        </OverlayTrigger>
      </React.Fragment>
    );
  };

  const handleDeleteInsuranceDoc = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
    if (result.isConfirmed) {
      dispatch(deleteDocument(id));
    }
  }

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (workflowTask?.ciid && viewType !== "candidateList") {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid > 0) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentDeleteStatusSelector])

  const handleUploadDocModalShowHide = (type) => {
    if (type === "save") {
      setDocShowHide(false);
      setUploadType("");
      refereshFormData();
    }
    else {
      setDocShowHide(!docShowHide);
      setUploadType(type);
    }
  }

  const getModifiedFiledData = (ddType, name) => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      const dt = getFieldData(app?.applicationData, ddType, name);
      if (!dt) return "";
      return <Moment format="MMM Do YYYY">{dt}</Moment>
    } else {
      const dt = getFieldData(partnerAppData, ddType, name);
      if (!dt) return "";
      return <Moment format="MMM Do YYYY">{dt}</Moment>
    }

  }

  const getPolicyDate = (ddType, name) => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      const dt = getFieldData(app?.applicationData, ddType, name);
      if (!dt) return "";
      return dt
    } else {
      const dt = getFieldData(partnerAppData, ddType, name);
      if (!dt) return "";
      return dt
    }

  }

  const addReqFormLibrary = () => {
    if (partnerCurrentWfTask?.ciid > 0 || workflowTask?.ciid > 0) {
      const insObj = {
        formId: 22,
        formName: "Insurance Details",
        remarks:
          "Upload your company's insurance certificate(s) as per the contract requirements",
        formType: "Insurance Information",
      };
      const frmData = new FormData();
      if (viewType === "candidateList")
        frmData.append("workflowTask", JSON.stringify(partnerCurrentWfTask));
      else
        frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("formId", insObj.formId);
      frmData.append("formName", insObj.formName);
      frmData.append("remarks", insObj.remarks);
      frmData.append("id", "");
      frmData.append("formType", insObj.formType);
      frmData.append("status", "1");
      dispatch(addFormLibrary(frmData));
    }

  };

  useEffect(() => {
    if (libraryFormAddedStatusSelector) {
      getAlert("", "Added Successfully", "success");
      // if (partnerCurrentWfTask?.ciid > 0 || workflowTask?.ciid > 0) {
      //   if (viewType === "candidateList")
      //     dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
      //   else
      //     dispatch(loadAppLibraryForms(workflowTask.ciid));
      // }
      if (workflowTask?.ciid > 0) {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
    }
  }, [libraryFormAddedStatusSelector])

  const refereshFormData = () => {
    // if (partnerCurrentWfTask?.ciid > 0) {
    //   setPartnerCurrentWfTask(null);
    //   if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
    //     dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid))

    //   if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
    //     dispatch(loadRecruiterWfTask(item?.recruiter?.parentid))
    // }
    if (workflowTask?.ciid > 0) {
      //dispatch(loadAppLibraryForms(workflowTask.ciid));
      //dispatch(loadDocuments(workflowTask.ciid));
      var frmBody = new FormData();
      frmBody.append("id", insuranceType === "Candidate" ? item.performerid : item.fuid);
      frmBody.append("name", "");
      frmBody.append("email", "");
      frmBody.append("type", "");
      if (insuranceType === "Recruiter")
        dispatch(loadRecruiterById(frmBody));
      else if (insuranceType === "Subcontractor")
        dispatch(loadSubcontractorById(frmBody));
      else if (insuranceType === "Candidate") {
        frmBody.append("entity", "");
        frmBody.append("filterType", "single");
        dispatch(loadCandidateById(frmBody))
      }
    }
  }

  const handleDocumentLoad = () => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      setTimeout(() => {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }, 3000);

      setTimeout(() => {
        dispatch(loadDocuments(workflowTask.ciid));
      }, 2000);

      setTimeout(() => {
        refereshFormData();
      }, 1000);
    }
    // else if (partnerCurrentWfTask?.ciid > 0) {
    //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
    //   dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
    // }
  }

  useEffect(() => {
    console.log(recruiterByIdSelector)
    if (recruiterByIdSelector.length > 0) {
      var part = recruiterByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [recruiterByIdSelector])

  useEffect(() => {
    console.log(subcontractorByIdSelector)
    if (subcontractorByIdSelector.length > 0) {
      var part = subcontractorByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [subcontractorByIdSelector])

  useEffect(() => {
    console.log(subcontractorByIdSelector)
    if (candidateByIdSelector.length > 0) {
      var part = candidateByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [candidateByIdSelector])

  const handleTimerModalShowHide = () => {
    setTimerShowHide(!timerShowHide);
  };

  let candidateObj = "";
  if (item) {
    candidateObj = {
      performerid: item?.id,
      applicantId: item?.id,
    };

    if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
      candidateObj.applicantId = item?.subcontractor?.parentid;

    if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
      candidateObj.applicantId = item?.recruiter?.parentid;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-6 text-left">
          <button
            className="btn btn-sm btn-link pl-0 mr-0"
            onClick={handleDocumentLoad}
          >
            Refresh
          </button>

        </div>
        <div className="col-md-6 text-right">
          <button
            className="btn btn-sm btn-link"
            onClick={handleTimerModalShowHide}
          >
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            Expiration Alert <span className="badge badge-pill badge-danger ml-0">{tmrMessages.length}</span>
          </button>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table align-items-center table-flush table-hover table-striped border">
          <thead className="thead-light">
            <tr>
              {/* <th>S.No.</th> */}
              <th>Company</th>
              <th>Insurance Information</th>
              <th>Last Updated</th>
              <th>View Form</th>
              <th>COI</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {formsLib.map((item, key) => (
              <tr>
                {/* <td>{key + 1}</td> */}
                <td className="text-wrap">
                  {
                    workflowTask?.ciid && viewType !== "candidateList" ?
                      getFieldData(
                        app?.applicationData,
                        "insurancedetails",
                        "Name_of_the_Insurance_Company"
                      ) :
                      getFieldData(
                        partnerAppData,
                        "insurancedetails",
                        "Name_of_the_Insurance_Company"
                      )
                  }
                </td>
                <td>
                  <React.Fragment>
                    <table>
                      {/* <tr>
                        <th>Type of Insurance</th>
                        <th>Policy Number</th>
                        <th>Expiration Date</th>
                      </tr> */}
                      <tr>
                        <td className="text-nowrap">Commercial General Liability</td>
                        <td>
                          {getPolicyDate("insurancedetails", "Commercial_General_Liability_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "Commercial_General_Liability_Expiration"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap">Automobile Liability</td>
                        <td>
                          {getPolicyDate("insurancedetails", "Automobile_Liability_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "Automobile_Liability_Expiration"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap">Umbrella Liability</td>
                        <td>
                          {getPolicyDate("insurancedetails", "Umbrella_Liab_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "Umbrella_Liab_Expiration"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap">
                          Workers Compensation and Employer's Liability
                        </td>
                        <td>
                          {getPolicyDate("insurancedetails", "Workers_Compensation_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "Workers_Compensation_Expiration"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap">Cyber and Privacy Security Liability</td>
                        <td>
                          {getPolicyDate("insurancedetails", "Cyber_Privacy_Security_Liab_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "Cyber_Privacy_Security_Liab_Expiration"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap">E&O Liability</td>
                        <td>
                          {getPolicyDate("insurancedetails", "E_and_O_Liab_Policy_Number")}
                        </td>
                        <td>
                          {getModifiedFiledData("insurancedetails",
                            "E_and_O_Liab_Expiration"
                          )}
                        </td>
                      </tr>
                    </table>
                  </React.Fragment>
                </td>
                <td>
                  {item.lastUpdate && (
                    <>
                      <Moment format="MMM Do YYYY">
                        {item.lastUpdate}
                      </Moment>
                      <br />
                      <Moment format="h:mm a">{item.lastUpdate}</Moment>
                    </>
                  )}
                </td>
                <td className="text-wrap">
                  <button
                    className="btn btn-link btn-sm p-0"
                    onClick={() => handleFormShowHide(item)}
                  >
                    View/Edit
                  </button>
                  <br />
                  {item.allowEdit === 0 && (
                    <span>
                      Edit Locked
                    </span>
                  )}
                  {item.allowEdit === 2 && (
                    <>
                      <span>Edit Request Received</span>
                      <br />
                      {item.editReqDateTime && <Moment format="MMM Do YYYY, h:mm a">
                        {item.editReqDateTime}
                      </Moment>}

                      <br />
                      {item.editRemarks}
                    </>
                  )}
                </td>
                <td className="text-wrap">
                  {handleCOIDoc(item)}
                </td>
                <td className="text-wrap">
                  {item.allowEdit === 2 && (
                    <button
                      className="btn btn-link btn-sm p-0 text-nowrap"
                      onClick={() => handleNoteShowHide("", item)}
                    >
                      Edit Allow
                    </button>
                  )}
                  {item.allowEdit === 1 && (
                    <>
                      <span className="text-nowrap">
                        Edit Allowed
                      </span>
                      <br />
                      {item.allowEditDateTime && (
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.allowEditDateTime}
                        </Moment>
                      )}
                      <br />
                      {item.editRemarks}
                    </>
                  )}
                </td>
              </tr>
            ))}
            {formsLib.length === 0 && achCheckCount === 2 && <tr>
              <td>{1}</td>
              <td colSpan={4}></td>
              <td>
                <button className="btn btn-sm btn-outline-default" onClick={() => addReqFormLibrary()}>Update</button>
              </td>
            </tr>}
          </tbody>
        </table>
      </div>

      {achFormShowHide && <ViewFormModal
        viewFormShowHide={achFormShowHide}
        handleViewForm={handleFormShowHide}
        workflowTask={viewType === "candidateList" ? partnerCurrentWfTask : workflowTask}
        selectedForm={selectedForm}
        refereshFormData={refereshFormData}
        formName="Insurance Information"
      ></ViewFormModal>}

      {noteShowHide && <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNoteShowHide}
        notesType="formEditReq"
        candidateObj={candidateObj}
        selectedObj={selectedForm}
      ></AddEditNotes>}


      {docShowHide && <CandidateReqDoc
        docShowHide={docShowHide}
        handleDocShowHide={handleUploadDocModalShowHide}
        workItem={viewType === "candidateList" ? partnerCurrentWfTask : workflowTask}
        sendType={"upload"}
        uploadType={uploadType}
        viewType={"candidateList"}
        applicantObj={candidateObj}
      ></CandidateReqDoc>}

      {timerShowHide &&
        <TimerPopup
          timerShowHide={timerShowHide}
          handleTimerModalShowHide={handleTimerModalShowHide}
          tmrMessages={tmrMessages}
        ></TimerPopup>}
    </>
  );
}

export default InsuranseInformation;
